import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import './Navbar.css';

const Navbar = ({ author }) => {
    const { isLoggedIn } = useAuth();

    return (
        <header className="navbar">
            <NavLink to="/" className="nav-logo">LOGAN REID <span className="accent">PARKER</span></NavLink>
            <nav className="nav-links">
                <NavLink to="/" end>Főoldal</NavLink>
                <NavLink to="/rolam">Rólam</NavLink>
                <NavLink to="/konyveim">Könyveim</NavLink>
                <NavLink to="/kapcsolat">Kapcsolat</NavLink>
                {isLoggedIn && ( <NavLink to="/admin">ADMIN</NavLink> )}
            </nav>
        </header>
    )
};
export default Navbar;